import React from 'react'

const LanguageForm = () => {
  return (
    <div>
        <form>
                

                <input type="text" placeholder='language1'/>
                <input type="text" placeholder='language2'/>


                <input type="submit" value="UPDATE"  className='update'/>

            
            
            </form>
    </div>
  )
}

export default LanguageForm